import Vue from 'vue';
import Vuetify from 'vuetify';
import colors from 'vuetify/lib/util/colors';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

const opts = {
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: colors.green.darken2,
        secondary: colors.blue.lighten1,
        tertiary: colors.grey.lighten4,
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        grey: colors.grey.base,
        purple: colors.purple.base,
        brown: colors.brown.base
      }
    }
  }
};

export default new Vuetify(opts);
